import * as Mod1 from "./discourse/assigned-group-route-map";
import * as Mod2 from "./discourse/assigned-messages-route-map";
import * as Mod3 from "./discourse/assigns-activity-route-map";
import * as Mod4 from "./discourse/components/assign-actions-dropdown";
import * as Mod5 from "./discourse/components/assign-button";
import * as Mod6 from "./discourse/components/assign-user-form";
import * as Mod7 from "./discourse/components/assigned-to-first-post";
import * as Mod8 from "./discourse/components/assigned-to-post";
import * as Mod9 from "./discourse/components/assigned-to";
import * as Mod10 from "./discourse/components/assigned-topic-list-column";
import * as Mod11 from "./discourse/components/assignment";
import * as Mod12 from "./discourse/components/bulk-actions/bulk-assign-user";
import * as Mod13 from "./discourse/components/group-assigned-filter";
import * as Mod14 from "./discourse/components/group-assigned-menu-item";
import * as Mod15 from "./discourse/components/modal/assign-user";
import * as Mod16 from "./discourse/components/modal/edit-topic-assignments";
import * as Mod17 from "./discourse/components/post-assignments-display";
import * as Mod18 from "./discourse/components/remind-assigns-frequency";
import * as Mod19 from "./discourse/components/topic-assignments";
import * as Mod20 from "./discourse/components/topic-level-assign-menu";
import * as Mod21 from "./discourse/components/user-menu/assigns-list-empty-state";
import * as Mod22 from "./discourse/components/user-menu/assigns-list";
import * as Mod23 from "./discourse/connectors/advanced-search-options-below/assigned-advanced-search.gjs";
import * as Mod24 from "./discourse/connectors/category-custom-settings/assign-settings-upsert.gjs";
import * as Mod25 from "./discourse/connectors/group-reports-nav-item/assigned-topic-list.gjs";
import * as Mod26 from "./discourse/connectors/groups-interaction-custom-options/assignable-interaction-fields.gjs";
import * as Mod27 from "./discourse/connectors/user-activity-bottom/assigned-list.gjs";
import * as Mod28 from "./discourse/connectors/user-preferences-notifications/remind-assigns-frequency.gjs";
import * as Mod29 from "./discourse/connectors/user-preferences-tracking-topics/notification-level-when-assigned.gjs";
import * as Mod30 from "./discourse/controllers/group/assigned";
import * as Mod31 from "./discourse/controllers/group/assigned/show";
import * as Mod32 from "./discourse/controllers/user-activity/assigned";
import * as Mod33 from "./discourse/initializers/assign-admin-plugin-configuration-nav";
import * as Mod34 from "./discourse/initializers/assign-extend-user-messages";
import * as Mod35 from "./discourse/initializers/assign-user-menu";
import * as Mod36 from "./discourse/initializers/assignment-list-actions";
import * as Mod37 from "./discourse/initializers/extend-for-assigns";
import * as Mod38 from "./discourse/lib/assignment-payload";
import * as Mod39 from "./discourse/lib/url";
import * as Mod40 from "./discourse/models/assignment";
import * as Mod41 from "./discourse/models/topic";
import * as Mod42 from "./discourse/pre-initializers/extend-category-for-assign";
import * as Mod43 from "./discourse/routes/group/assigned";
import * as Mod44 from "./discourse/routes/group/assigned/show";
import * as Mod45 from "./discourse/routes/user-activity/assigned";
import * as Mod46 from "./discourse/routes/user-private-messages/assigned";
import * as Mod47 from "./discourse/routes/user-private-messages/assigned/index";
import * as Mod48 from "./discourse/services/task-actions";
import * as Mod49 from "./discourse/templates/group/assigned";
import * as Mod50 from "./discourse/templates/group/assigned/show";
import * as Mod51 from "./discourse/templates/user-activity/assigned";
import * as Mod52 from "./discourse/templates/user-private-messages/assigned";
const compatModules = {
  "discourse/assigned-group-route-map": Mod1,
  "discourse/assigned-messages-route-map": Mod2,
  "discourse/assigns-activity-route-map": Mod3,
  "discourse/components/assign-actions-dropdown": Mod4,
  "discourse/components/assign-button": Mod5,
  "discourse/components/assign-user-form": Mod6,
  "discourse/components/assigned-to-first-post": Mod7,
  "discourse/components/assigned-to-post": Mod8,
  "discourse/components/assigned-to": Mod9,
  "discourse/components/assigned-topic-list-column": Mod10,
  "discourse/components/assignment": Mod11,
  "discourse/components/bulk-actions/bulk-assign-user": Mod12,
  "discourse/components/group-assigned-filter": Mod13,
  "discourse/components/group-assigned-menu-item": Mod14,
  "discourse/components/modal/assign-user": Mod15,
  "discourse/components/modal/edit-topic-assignments": Mod16,
  "discourse/components/post-assignments-display": Mod17,
  "discourse/components/remind-assigns-frequency": Mod18,
  "discourse/components/topic-assignments": Mod19,
  "discourse/components/topic-level-assign-menu": Mod20,
  "discourse/components/user-menu/assigns-list-empty-state": Mod21,
  "discourse/components/user-menu/assigns-list": Mod22,
  "discourse/connectors/advanced-search-options-below/assigned-advanced-search": Mod23,
  "discourse/connectors/category-custom-settings/assign-settings-upsert": Mod24,
  "discourse/connectors/group-reports-nav-item/assigned-topic-list": Mod25,
  "discourse/connectors/groups-interaction-custom-options/assignable-interaction-fields": Mod26,
  "discourse/connectors/user-activity-bottom/assigned-list": Mod27,
  "discourse/connectors/user-preferences-notifications/remind-assigns-frequency": Mod28,
  "discourse/connectors/user-preferences-tracking-topics/notification-level-when-assigned": Mod29,
  "discourse/controllers/group/assigned": Mod30,
  "discourse/controllers/group/assigned/show": Mod31,
  "discourse/controllers/user-activity/assigned": Mod32,
  "discourse/initializers/assign-admin-plugin-configuration-nav": Mod33,
  "discourse/initializers/assign-extend-user-messages": Mod34,
  "discourse/initializers/assign-user-menu": Mod35,
  "discourse/initializers/assignment-list-actions": Mod36,
  "discourse/initializers/extend-for-assigns": Mod37,
  "discourse/lib/assignment-payload": Mod38,
  "discourse/lib/url": Mod39,
  "discourse/models/assignment": Mod40,
  "discourse/models/topic": Mod41,
  "discourse/pre-initializers/extend-category-for-assign": Mod42,
  "discourse/routes/group/assigned": Mod43,
  "discourse/routes/group/assigned/show": Mod44,
  "discourse/routes/user-activity/assigned": Mod45,
  "discourse/routes/user-private-messages/assigned": Mod46,
  "discourse/routes/user-private-messages/assigned/index": Mod47,
  "discourse/services/task-actions": Mod48,
  "discourse/templates/group/assigned": Mod49,
  "discourse/templates/group/assigned/show": Mod50,
  "discourse/templates/user-activity/assigned": Mod51,
  "discourse/templates/user-private-messages/assigned": Mod52,
};
export { compatModules };
export default compatModules;
